import { Login, LoginForm } from "react-admin";
import classes from "./LoginPage.module.css";

const LoginPage = () => {
  return (
    <div className={classes.container}>
      <section className={classes.brandPanel} aria-label="Acura Nexus">                
        <h1 className={classes.brandTitle}>
          Welcome to <span>Acura Nexus</span>
        </h1>
        <p className={classes.brandDescription}>
          Satu ruang kerja untuk mengelola operasional bisnis dengan lebih
          terhubung, cepat, dan terarah.
        </p>
      </section>

      <Login
        className={classes.login}
        sx={{
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: "none",
        }}
      >
        <LoginForm />
      </Login>
    </div>
  );
};
export default LoginPage;
